import * as CryptoJS from "crypto-js";

class Encryption {
    public encrypt(plainText: string, salt: string): string {
        const key = CryptoJS.enc.Utf8.parse(salt);
        const iv = CryptoJS.enc.Utf8.parse(salt);
        const encrypted = CryptoJS.AES.encrypt(plainText, key, {
            iv: iv,
            keySize: 128 / 8,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    }
    public localEncrypt(plainText: string): string {
        let mask = '';
        const chars = "aA";
        const length = 16;
        if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
        if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let result = '';
        for (var i = length; i > 0; --i) result += mask[Math.floor(Math.random() * mask.length)];
        const encryptPassword =result + CryptoJS.AES.encrypt(plainText,result);
        return encryptPassword;
    }
    public localDecrypt(cipher: string): string {
        const passPhrase = cipher.substring(0,16);   
        const pass = cipher.substring(16);
        return CryptoJS.AES.decrypt(pass,passPhrase).toString(CryptoJS.enc.Utf8);
    }
}
const encryption = new Encryption();
export default encryption;